<mat-dialog-content class="p-0">
  <div class="dialog">
    <p class="text-end">
      <span mat-button mat-dialog-close>

        <svg xmlns="http://www.w3.org/2000/svg" width="13.998" height="13.998" viewBox="0 0 13.998 13.998">
          <path id="close-btn"
            d="M8.177-11.911,6.768-13.32l-5.59,5.59-5.59-5.59L-5.82-11.911l5.59,5.59L-5.82-.732-4.411.677l5.59-5.59L6.768.677,8.177-.732l-5.59-5.59Z"
            transform="translate(5.82 13.32)" fill="#bbb" />
        </svg>
      </span>
    </p>


    <div class="suspend">
      <ng-container>
        <svg xmlns="http://www.w3.org/2000/svg" width="160" height="160.375" viewBox="0 0 160 160.375">
          <g id="top-bidder-ic" transform="translate(-880 -200)">
            <circle id="circle" cx="80" cy="80" r="80" transform="translate(880 200)" fill="#fdeee7" />
            <g id="biiding-winner-ic" transform="translate(-758.365 14953.533)" opacity="0.3">
              <g id="Group_10976" data-name="Group 10976" transform="translate(1665.964 -14721.935)">
                <path id="XMLID_535_"
                  d="M102.95,4.1H83.262V2.051A2.051,2.051,0,0,0,81.211,0H35.479a2.051,2.051,0,1,0,0,4.1H79.16V38.145a26.66,26.66,0,0,1-53.32,0V4.1H43.272a2.051,2.051,0,1,0,0-4.1H23.789a2.051,2.051,0,0,0-2.051,2.051V4.1H2.051A2.051,2.051,0,0,0,0,6.152V29.121a20.12,20.12,0,0,0,20.1,20.1h3.629c.025,0,.049,0,.073,0A30.9,30.9,0,0,0,43.887,67.677v8.612H40.605A15.6,15.6,0,0,0,25.019,91.875v11.074A2.051,2.051,0,0,0,27.07,105H77.93a2.051,2.051,0,0,0,2.051-2.051V91.875A15.6,15.6,0,0,0,64.394,76.289H61.113V67.677A30.9,30.9,0,0,0,81.2,49.215c.025,0,.049,0,.073,0H84.9a20.12,20.12,0,0,0,20.1-20.1V6.152A2.05,2.05,0,0,0,102.95,4.1ZM20.1,36.914A7.8,7.8,0,0,1,12.3,29.121V16.406h9.434V36.914Zm0,8.2a16.014,16.014,0,0,1-16-16V8.2H21.738v4.1H10.254A2.051,2.051,0,0,0,8.2,14.355V29.121A11.908,11.908,0,0,0,20.1,41.016h1.776a30.589,30.589,0,0,0,.662,4.1ZM75.879,91.875V100.9H29.121V91.875A11.5,11.5,0,0,1,40.606,80.391H64.395A11.5,11.5,0,0,1,75.879,91.875ZM57.012,76.289H47.988V68.575a30.857,30.857,0,0,0,9.023,0Zm26.25-59.883H92.7V29.121A7.8,7.8,0,0,1,84.9,36.914H83.262ZM100.9,29.121a16.014,16.014,0,0,1-16,16H82.465a30.589,30.589,0,0,0,.662-4.1H84.9A11.908,11.908,0,0,0,96.8,29.121V14.355A2.051,2.051,0,0,0,94.747,12.3H83.262V8.2H100.9Z"
                  fill="#e9580e" />
                <path id="XMLID_557_"
                  d="M164.4,67.439l1.63,1.63L155.316,79.786A6.141,6.141,0,1,0,164,88.47l8.67-8.67v7.348a2.047,2.047,0,0,0,2.047,2.047h18.713a2.047,2.047,0,0,0,2.047-2.047V78.756a2.047,2.047,0,0,0-2.047-2.047h-7.014l1.992-1.992a5.5,5.5,0,0,0,0-7.777L176.654,55.187a5.5,5.5,0,0,0-7.777,0L164.4,59.662a5.505,5.505,0,0,0,0,7.777Zm-3.3,18.136a2.047,2.047,0,0,1-2.895-2.895l10.717-10.717,2.895,2.895Zm30.277-.474H176.763V80.8h14.619ZM167.3,62.557l4.476-4.475a1.407,1.407,0,0,1,1.987,0l11.753,11.753a1.407,1.407,0,0,1,0,1.987L181.037,76.3a1.406,1.406,0,0,1-1.987,0L167.3,64.544a1.406,1.406,0,0,1,0-1.987Z"
                  transform="translate(-121.997 -42.609)" fill="#f08a56" />
                <path id="XMLID_781_"
                  d="M190,434.047a2.047,2.047,0,0,0,2.047,2.047h22.925a2.047,2.047,0,0,0,0-4.094H192.047A2.047,2.047,0,0,0,190,434.047Z"
                  transform="translate(-151.01 -343.375)" fill="#e9580e" />
              </g>
            </g>
            <g id="warning" transform="translate(0 -7.937)">
              <path id="warning-2" data-name="warning"
                d="M10.868,75.367h63.2a8.391,8.391,0,0,0,7.26-12.59l-31.6-54.6a8.389,8.389,0,0,0-14.52,0l-31.6,54.6a8.391,8.391,0,0,0,7.26,12.59Z"
                transform="translate(877.531 292.944)" fill="#f7c600" />
              <path id="Union_36" data-name="Union 36"
                d="M10779,15249.478a4,4,0,1,1,4,4A4,4,0,0,1,10779,15249.478Zm0-13.574v-15.394a4.2,4.2,0,1,1,8.395,0v15.394a4.2,4.2,0,0,1-8.395,0Z"
                transform="translate(-9863 -14896.164)" fill="#fff" />
            </g>
          </g>
        </svg>

        <h4 class="title mt-4">{{"items-requests.You've made the highest bid" | translate}}</h4>


        <div class="you-balance">
          <div class="increase-last-bid">
            <p class="txt mb-2">{{'Auction Item.Your last bid' | translate}}</p>
            <p class="price">{{"Auction Item.SR"|translate}} <b>{{ data.number |number}}</b></p>
          </div>
          <div class="current-balance">
            <p class="txt mb-2">{{'items-requests.Current Balance' | translate}}</p>
            <p class="price">{{"Auction Item.SR"|translate}} <b>{{data.myBlanace | number}}</b></p>
          </div>
        </div>

        <div class="hint">
          {{'items-requests.To win this item, you must pay' | translate}} {{"Auction Item.SR"|translate}} <b>{{data.raisePrice | number}}</b> +  {{data.auctionData.commission}} % {{'items-requests.commission' | translate}}  {{'items-requests.more to meet the reserve price' | translate}}
        </div>
        <div class="wallet-balance mb-4">
          <p class="txt mb-2">{{'Auction Item.Current wallet balance' | translate}}</p>
          <div class="price">{{"Auction Item.SR"|translate}} <b>{{data.myBlanace}}</b></div>
        </div>

        <!-- <div class="wallet-balance mb-4">
          <p class="txt mb-2"> Hurry! Make your decision before:</p>
          <p class="timer">{{countdownString}}</p>
        </div> -->

        <div class="actions-join mt-2">
          <button mat-button mat-dialog-close class="btnLight_fill me-3" [appLoading]="loading">{{'items-requests.No, Thanks' | translate}}</button>
          <button *ngIf="data.raisePrice > data.myBlanace" (click)="topUp()" mat-button class="btn_fill" type="submit"
            [appLoading]="loading">{{'items-requests.Top-up wallet and pay' | translate}} </button>
          <button *ngIf="data.myBlanace > data.raisePrice" (click)="confirm()" mat-button class="btn_fill" type="submit"
            [appLoading]="loading">{{'items-requests.Increase bid by' | translate}} {{"Auction Item.SR"|translate}} <b>{{data.raisePrice | number}} </b></button>
        </div>

        <!-- <div class="actions">
          <button mat-button mat-dialog-close class="btnLight_fill me-3" [appLoading]="loading">{{'items-requests.No, Thanks' | translate}}</button>
          <button *ngIf="data.raisePrice > data.myBlanace" (click)="topUp()" mat-button class="btn_fill" type="submit"
            [appLoading]="loading">{{'items-requests.Top-up wallet and pay' | translate}} </button>
          <button *ngIf="data.myBlanace > data.raisePrice" (click)="confirm()" mat-button class="btn_fill" type="submit"
            [appLoading]="loading">{{'items-requests.Increase bid by' | translate}} sr <b>{{data.raisePrice | number}} </b></button>
        </div> -->


      </ng-container>

    </div>
  </div>
</mat-dialog-content>